<template>
  <div>
    <div class="flex-wrap d-flex" style="gap: 10px">
      <UploadMultiple
        :lsData="items"
        fileType="file"
        accept="*/*"
        @syncFile="syncFiles"
        title="File phụ lục PDF"
      />
    </div>
    <button
      :disabled="!(files && files.length > 0)"
      @click="uploadFiles"
      class="btn btn-success float-right"
    >
      Lưu
    </button>
    <VueLoadingOverlay
      style="z-index: 5 !important"
      :active.sync="showLoading"
      :is-full-page="false"
    ></VueLoadingOverlay>
  </div>
</template>
<script>
  import { ContractService } from '@/services/contract.service'
  import { CommonService } from '@/services/common.service'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      contractId: {
        type: String,
      },
      appendixId: {
        type: String,
      },
    },
    components: { UploadMultiple },
    data() {
      return {
        showLoading: false,
        files: null,
      }
    },
    methods: {
      syncFiles(fileUploads) {
        this.files = fileUploads
      },
      async sendFile(item, type) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          try {
            let data
            if (type === 'video' || type === 'pdf') {
              data = await ContractService.uploadFileS3PDF(formData)
            } else {
              data = await CommonService.uploadImg(formData)
            }
            const urlFile = data.data[0]
            item.url = urlFile
            item.status = 'uploaded'
            return urlFile
          } catch (error) {
            throw new Error('lỗi upload file: ' + error)
          }
        } else return item.url ?? item
      },
      async uploadFiles() {
        this.showLoading = true
        try {
          if (this.appendixId) {
            const params = {
              appendixId: this.appendixId,
              urlPDFs: await Promise.all(this.files.map(s => this.sendFile(s, 'pdf'))),
            }
            const res = await ContractService.editFiles(params)
            if (res.success) {
              this.showSuccessMx('Cập nhật phụ lục VISA thành công').then(s => {
                this.$bvModal.hide('formAppendixVisa')
              })
            } else this.showFailMx(res.message ?? res.error)
          } else {
            const params = {
              contractId: this.contractId,
              pdfs: await Promise.all(this.files.map(s => this.sendFile(s, 'pdf'))),
            }
            const res = await ContractService.createVisaAppendix(params)
            if (res.success) {
              this.files = null
              this.showSuccessMx('Tạo phụ lục VISA thành công').then(s => {
                this.$bvModal.hide('formAppendixVisa')
              })
            } else this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped></style>
